module.exports = __webpack_public_path__ + "img/e.7250e609.jpg";